import { Link } from 'react-router-dom';
import { MapPin, ArrowUpRight } from 'lucide-react';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function Coverage() {
  const t = useT();
  const { AREAS } = useContent();

  return (
    <section data-testid="coverage-section" className="bg-ink py-24 md:py-32">
      <div className="container-site">
        <Chapter n={8} label={t['ch.coverage']} />
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <FadeUp>
            <h2 className="font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
              {t['cv.h2a']}<span className="italic text-gold">{t['cv.h2b']}</span>
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-silver">{t['cv.p']}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              {AREAS.map((a) => (
                <Link key={a.slug} data-testid={`area-chip-${a.slug}`} to={`/areas/${a.slug}`}
                  className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2.5 text-sm font-semibold text-white/85 transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold hover:text-gold">
                  <MapPin className="h-4 w-4 text-gold" /> {a.name} <ArrowUpRight className="h-3.5 w-3.5 opacity-50" />
                </Link>
              ))}
            </div>
          </FadeUp>
          <FadeUp delay={0.15}>
            <div className="overflow-hidden rounded-xl border border-white/10 shadow-2xl">
              <iframe data-testid="coverage-map" title={t['cv.mapTitle']}
                src="https://maps.google.com/maps?q=Orleans%2C%20Ottawa%2C%20ON%2C%20Canada&z=10&output=embed"
                className="h-[380px] w-full grayscale-[0.4] contrast-[1.05]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
